/**
 * Scrolls the element with the given id into view. Safe when id is missing.
 */
export function scrollToElementById(elementId, options) {
  if (!elementId || typeof document === "undefined") return;
  const el = document.getElementById(elementId);
  if (!el) return;
  el.scrollIntoView(options ?? { behavior: "smooth", block: "start" });
}
